import React, {useCallback, useEffect, useState} from 'react'
import {Box, ThemeProvider} from '@mui/material'
import {theme} from '../../../theme/DashboardTheme'
import CenteredTabs from '../../Views/Tabs'
import RemovalStats from './RemovalStats'
import OptOuts from './OptOuts'
import {useAppDispatch, useAppSelector} from '../../../redux/storeExports'
import {selectActiveGrant} from '@meprism/shared/src/redux/product/ProductSlice'
import {fetchOptOuts, selectOptOuts, fetchBrokers} from "@meprism/shared/src/redux/peopleFinder/PeopleFinderSlice";
import AnalyticsManager from '../../../services/AnalyticsManager'

const DashboardGrid = () => {
  const [tabValue, setTabValue] = useState('Removal Stats')
  const dispatch = useAppDispatch()
  const grant = useAppSelector(selectActiveGrant)
  const optouts = useAppSelector(selectOptOuts)
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue)
    AnalyticsManager.trackTypedEvent({
      event: 'Page View - Web',
      path: tabValue==='Opt Out Requests' ? '/dashboard/OptOutTab' : '/dashboard/RemovalsTab',
      search: '',
      source: 'Web App'
    })
  }
  const [isFetchingOptOuts, setIsFetchingOptOuts] = useState(true)
  const [isFetchingBrokers, setIsFetchingBrokers] = useState(true)
  const fetchOptoutResults = useCallback(async () => {
    setIsFetchingOptOuts(true)
    await dispatch(fetchOptOuts())
    setIsFetchingOptOuts(false)
  }, [dispatch])

  const fetchBrokerResults = useCallback(async () => {
    setIsFetchingBrokers(true)
    await dispatch(fetchBrokers())
    setIsFetchingBrokers(false)
  },[dispatch])

  useEffect(() => {
    fetchOptoutResults()
    fetchBrokerResults()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // ToDo: We will remove this check once blast emails are sent out to all those subscribers who have purchased a grant before 2025-01-21
  const isGrantDateValid =
    !grant?.active ||
    (grant?.grant_purchase_date &&
      new Date(grant.grant_purchase_date) > new Date('2025-01-21') || optouts.length > 0)

  return (
    <Box
      sx={{
        '& .MuiCircularProgress-root': {
          color: '#1976D2',
          marginTop: 40,
        },
      }}>
        <ThemeProvider theme={theme}>
          <CenteredTabs
            value={tabValue}
            handleChange={handleTabChange}
            isGrantDateValid={isGrantDateValid}
          />

          {tabValue === 'Removal Stats' ? (
            <RemovalStats grant={grant} isLoading={isFetchingBrokers}/>
          ) : (
            <OptOuts grant={grant} optouts={optouts} isLoading={isFetchingOptOuts}/>
          )}
        </ThemeProvider>
    </Box>
  )
}

export default DashboardGrid
